import { RouterProvider } from "react-router-dom";

import { router } from "@/routes/router";

/** Application root: the permission-guarded route tree. */
export default function App() {
  return <RouterProvider router={router} />;
}

